var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-generated",domProps:{"innerHTML":_vm._s(_vm.contents.health_safety_1.body)}})
}
var staticRenderFns = []

export { render, staticRenderFns }